import { Switch, Tooltip } from '@mui/material';

export const AbvOverUnderScenReasonablenessToggle = ({ reasonablenessFlag, setReasonablenessFlag }) => {

    return (
        <Tooltip title={'Reasonableness Toggle'} >
            <Switch
                color={'success'}
                checked={reasonablenessFlag}
                onChange={(e) => setReasonablenessFlag(e.target.checked)}
            />
        </Tooltip>
    )
}